/* Nuxt自动根据 ~/pages/ 目录下的.vue文件创建路由 */
/* 也可以在对应.vue文件中使用编译器宏 definePageMeta() 自定义路由信息 */

/* 不过为了方便统一定义路由，目前对于Nuxt项目，会通过 ~/app/router.options.ts 文件加载该脚本 */
/* 对于纯Vue项目，通过 ~/main.ts 加载该脚本 */

import * as VueRouter from 'vue-router'
import type {RouteRecordRaw} from 'vue-router'

import HomePage from '@/pages/HomePage.vue'
import AboutPage from '@/pages/AboutPage.vue'

import Softs from '@/router/softs'
import Agreements from '@/router/agreements'

export default <RouteRecordRaw[]> [
  ...Softs,
  ...Agreements,
  {
    name: 'home', path: '/',
    component: HomePage,
  },
  {
    name: 'about', path: '/about',
    // component: () => import('@/pages/AboutPage.vue'),
    component: AboutPage,
  },
]
